<template>
  <div class="pa-4 white" style="position: relative; border-radius: 4px">
    <VueMarkdown
      v-if="title"
      class="title mb-3"
      :source="title"
      :html="false"
      :xhtml-out="true"
      :breaks="true"
      :anchor-attributes="{ target: '_blank' }"
    />

    <VueMarkdown
      v-if="content"
      class="body-1 mb-3 translucid"
      :source="content"
      :html="false"
      :xhtml-out="true"
      :breaks="true"
      :anchor-attributes="{ target: '_blank' }"
    />

    <div v-if="html" v-html="html" />

    <el-input
      v-if="inputType == 'text' || inputType == 'password'"
      v-model="inputData"
      v-validate="validationRules"
      :name="inputName"
      :placeholder="inputPlaceholder"
      :type="inputType"
    />
    <v-select
      v-else-if="inputType == 'select'"
      v-model="inputData"
      v-validate="validationRules"
      class="ra-1 mt-4"
      :name="inputName"
      :items="items"
      :placeholder="inputPlaceholder"
      hide-details
      attach
      solo
    />
    <v-textarea
      v-else-if="inputType == 'textarea'"
      v-model="inputData"
      v-validate="validationRules"
      class="ra-1 mt-4"
      :name="inputName"
      :placeholder="inputPlaceholder"
      hide-details
      solo
    />

    <div style="height: 20px">
      <span
        v-show="errors.has(inputName)"
        class="text-small"
        style="color: #ff5767"
      >
        {{ errors.first(inputName) }}
      </span>
    </div>

    <div class="prompt-buttons">
      <v-btn
        flat
        class="grey--text"
        style="height: 48px; min-width: initial"
        @click="cancelButton"
      >
        CANCELAR
      </v-btn>
      <v-btn
        flat
        class="green--text"
        style="height: 48px; min-width: initial"
        @click="confirmButton"
      >
        CONFIRMAR
      </v-btn>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  name: "MaterialDialog",
  $_veeValidate: {
    validator: "new", // give me my own validator instance.
  },

  components: { VueMarkdown },

  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
    },
    html: {
      type: String,
    },
    inputPlaceholder: {
      type: String,
    },
    inputType: {
      type: String,
      default: "text",
    },
    items: {
      type: Array,
      default: null,
    },
    inputName: {
      type: String,
      default: "input",
    },
    validationRules: {
      default: "",
    },
    confirmed: {
      type: Boolean,
    },
  },
  data() {
    return {
      inputData: null,
    };
  },

  methods: {
    cancelButton() {
      this.$emit("close");
    },

    confirmButton() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("answer", this.inputData);
        }
      });
    },
  },
};
</script>

<style scoped>
.prompt-buttons {
  height: 48px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/MaterialPrompt.vue